<template>
    <div id="verify-webhook" class="td-edit-container one-step">
        <div class="pagination">
            <div class="form-name">
                <h3>Verify Webhook</h3>
            </div>
            <div class="step-description">
                <div class="step active">
                    <p>Instruction.</p>
                </div>
            </div>
        </div>
        <div class="edit-pages">
            <form>
                <h3>Verify Webhook</h3>
                <div>
                    <button class="td-btn primary-outlined" @click.prevent="sendCode" :disabled="isLoading"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Send Verification Code</button>
                </div>
                <div>
                    <div class="column">
                        <div class="mt-3">
                            <label class="td-label td-text-bold">Verification Code:</label>
                            <input class="td-input" v-model="code" type="text" placeholder="Enter the verification code received" />
                            <div class="input-errors" v-for="error of validation.code.$errors" :key="error.$uid">
                                <div class="error-msg td-banner no-icon slim danger">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="actions">
                <div>
                    <button class="td-btn primary-outlined" @click.prevent="cancelClick">Cancel</button>
                </div>
                <div class="save-btn">
                    <button class="td-btn btn primary" @click.prevent="verifyClick" :disabled="isLoading"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Verify</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import script from './VerifyWebhook';
    export default script;
</script>